import React from 'react'
import PropTypes from 'prop-types'
import FacilityProfileV2 from 'model/facilities/facilityProfileV2'
import Provider from 'model/provider/provider'
import { Tooltip } from 'antd'

import { Address, ConfidenceRating } from 'ui/entities/styled'

const EntityAddress = ({ entity, isColumn = false }) => {
  const { contacts } = entity || {}
  const confidence = contacts?.confidence
  const phone =
    contacts?.phone || contacts?.rightway_primary_phone || contacts?.phones?.[0]

  return (
    <>
      <Address alignLeft={isColumn} offsetTop={isColumn}>
        {entity?.contacts?.address}
      </Address>
      <Address alignLeft={isColumn}>{phone}</Address>
      <Address alignLeft={isColumn} offsetTop={isColumn}>
        {entity?.distance ? `${entity.distance} mi` : ''}
      </Address>
      {confidence && !isColumn && (
        <Address>
          <Tooltip title={`Location Confidence Level ${confidence}`}>
            <ConfidenceRating green={(confidence > 2).toString()}>
              {confidence}
            </ConfidenceRating>
          </Tooltip>
        </Address>
      )}
    </>
  )
}

EntityAddress.propTypes = {
  entity: PropTypes.oneOfType([
    PropTypes.instanceOf(FacilityProfileV2),
    PropTypes.instanceOf(Provider)
  ]).isRequired,
  isColumn: PropTypes.bool
}

export default EntityAddress
